import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { templateData } from '../data/templateData';
import './checkin.css';
import { useAuth } from '../hooks/useAuth';
import ProfessionalChatbot from '../components/ProfessionalChatbot';
import Alert from "../components/Alert";
import PhoneInput from "../components/PhoneInput"
import Voice from "../components/Voice2"
import VoiceChat from "../components/VoiceChat"
import '@livekit/components-styles';

const AutoCheckIn = () => {
  const { id } = useParams();
  const [adhoc, setAdhoc] = useState(false);
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user, logout } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  
  const [prompts_list, setPrompts_list] = useState([]);

  const [selected_prompts, setSelected_prompts] = useState({});

  const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
  
  const [alertMessage, setAlertMessage] = useState("");

  const [expandedKey, setExpandedKey] = useState(null);

  const toggleKey = (key) => {
    setExpandedKey(prev => (prev === key ? null : key));
  };


  const triggerAlert = (msg) => {
    setAlertMessage(msg);
    setShowAlert(true);
  };

    useEffect(() => {
    // Simulate API call
    console.log(id)

    setTimeout(() => {
      if (id == "Adhoc Task")
        setAdhoc(true)
      
      const foundtemplate = templateData.find(template => template.service === id);
      //console.log(id, "hello",foundtemplate)
      if (foundtemplate) {
        setTemplate(foundtemplate);
      } else {
        setError('assistant not found');
      }
      setLoading(false);
    }, 100);

  }, [id]);
  

  useEffect(
    () => {
      async function fetchData() {
        // You can await here
            const response = await fetch(API_URL+'/api/get_prompts',
                {
                  method: "GET",          
                  headers: { "Content-Type": "application/json","Authorization": "Bearer "+user.token },
                  
                }
              ) ;
            setPrompts_list(await response.json())
        
      }
    fetchData();

    // Simulate API call

    }, []);


  if (loading) {
    return <div>Loading details...</div>;
  }

  const addKeyValue = (key, value) => {
    setSelected_prompts(prevDict => ({
      ...prevDict,
      [key]: value,
    }));
  };

  // Remove a key-value pair
  const removeKey = (key) => {
    setSelected_prompts(prevDict => {
      const { [key]: _, ...rest } = prevDict; // Omit the key
      return rest;
    });
  };

  const handleSelect = (e) =>{

    console.log(e.target.value)
    if (e.target.name == "temperature" && e.target.value == "Fever"){
       console.log("FFFFFFFF")
       const fever = prompts_list.filter(item => item.prompt_id == 'fever_PROMPT')
       if (fever.length > 0)
           //question_list.push({"fever_PROMPT":fever[0].prompt})          
          addKeyValue("Fever",fever)         
        
    }else if (e.target.name == "temperature" && e.target.value != "Fever"){
      removeKey("Fever")
    }
  
    if (e.target.name == "spo2" && e.target.value == "Low"){
      console.log("FFFFFFFF")
      const fever = prompts_list.filter(item => item.prompt_id == 'SPO2_low_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("SPO2 Low",fever)         
       
   }else if (e.target.name == "spo2" && e.target.value != "Low"){
         removeKey("SPO2 Low")
   }


   if (e.target.name == "heartRate" && e.target.value == "High"){
    
    const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_High_PROMPT')
    if (fever.length > 0)
        //question_list.push({"fever_PROMPT":fever[0].prompt})          
       addKeyValue("Heart Rate High",fever)         
     
    }else if (e.target.name == "heartRate" && e.target.value != "High"){
          removeKey("Heart Rate High")
    }

    if (e.target.name == "heartRate" && e.target.value == "Low"){
    
      const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_Low_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("Heart Rate Low",fever)         
       
      }else if (e.target.name == "heartRate" && e.target.value != "Low"){
            removeKey("Heart Rate Low")
    }

    if (e.target.name == "bloodPressure" && e.target.value == "High"){
    
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_High_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("BP High",fever)         
       
      }else if (e.target.name == "bloodPressure" && e.target.value != "High"){
            removeKey("BP High")
    }    

    if (e.target.name == "bloodPressure" && e.target.value == "Low"){
    
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_Low_PROMPT')
      if (fever.length > 0)
          //question_list.push({"fever_PROMPT":fever[0].prompt})          
         addKeyValue("BP Low",fever)         
       
      }else if (e.target.name == "bloodPressure" && e.target.value != "Low"){
            removeKey("BP Low")
    }       

        
    // if (e.target.bloodPressure.value == "Low"){
    //   const fever = prompts_list.filter(item => item.prompt_id == 'BP_Low_PROMPT')
    //    if (fever.length > 0)
    //        //question_list.push({"BP_Low_PROMPT":fever[0].prompt})
    //        setSelected_prompts(prev => [...prev, {"fever_PROMPT":fever[0].prompt}]) 

    // }
      

    // console.log(selected_prompts)

  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit",e.target.name.value,e.target.phone.value)
    const question_list = {}

    let vital_signs = [0,0,0,0,0,0]
    if (e.target.temperature.value == "Fever"){
      console.log(prompts_list)
       const fever = prompts_list.filter(item => item.prompt_id == 'fever_PROMPT')
       if (fever.length > 0)
           //question_list.push({"Fever":fever[0].prompt.map(item => item.prompt)})
           question_list["Fever"] = fever[0].prompt.map(item => item.prompt)

    }
        // vital_signs[0] = 1
    if (e.target.spo2.value == "Low"){
       const fever = prompts_list.filter(item => item.prompt_id == 'SPO2_low_PROMPT')
       if (fever.length > 0)
           //question_list.push({"SPO2_Low":fever[0].prompt.map(item => item.prompt)})
           question_list["SPO2_Low"] = fever[0].prompt.map(item => item.prompt)
    }
        vital_signs[1] = 1
    if (e.target.heartRate.value == "High"){
      const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_High_PROMPT')
       if (fever.length > 0)
           //question_list.push({"Heart_Rate_High":fever[0].prompt.map(item => { if (item.followUps){return item.prompt + " - "+item.followUps.join(" - ")} else return item.prompt})})
           question_list["Heart_Rate_High"] = fever[0].prompt.map(item => { if (item.followUps){return item.prompt + " - "+item.followUps.join(" - ")} else return item.prompt})
    }
        vital_signs[2] = 1  
    if (e.target.heartRate.value == "Low"){
      const fever = prompts_list.filter(item => item.prompt_id == 'Heart_Rate_Low_PROMPT')
       if (fever.length > 0)
           //question_list.push({"Heart_Rate_Low":fever[0].prompt.map(item => item.prompt)})
           question_list["Heart_Rate_Low"] = fever[0].prompt.map(item => item.prompt)

    }
        vital_signs[3] = 1
    if (e.target.bloodPressure.value == "High"){
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_High_PROMPT')
       if (fever.length > 0)
           //question_list.push({"BP_High":fever[0].prompt.map(item => item.prompt)})
           question_list["BP_High"] = fever[0].prompt.map(item => item.prompt)

    }
        vital_signs[4] = 1
    if (e.target.bloodPressure.value == "Low"){
      const fever = prompts_list.filter(item => item.prompt_id == 'BP_Low_PROMPT')
       if (fever.length > 0)
           //question_list.push({"BP_Low":fever[0].prompt.map(item => item.prompt)})
           question_list["BP_Low"] = fever[0].prompt.map(item => item.prompt)

    }
        vital_signs[5] = 1
    if ( Object.keys(question_list).length == 0){
      //alert("Please select at least one abnormal option")
      triggerAlert("Please select at least one abnormal option")
      return 
    }

    console.log(question_list)
    //return

    const newTask = {
      "type":  "auto check-in",
      "name": e.target.name.value,
      "phone_number": e.target.phone_code.value+e.target.phone.value,      
      //"vital_signs":vital_signs,  
      "question_list":question_list,
      "lang": e.target.lang.value,   
    }
    if (e.target.time.value){
      newTask["call_at"] = e.target.time.value
    }

    // const data = {"agent_name":"test-call", "meta":{"vital_signs":vital_signs,"phone_number":e.target.phone.value,
    //                "name":e.target.name.value,"transfer_to":e.target.phone.value}}
    // console.log(e.target.time.value)
    // if (e.target.time.value){
    //     data["call_at"] = e.target.time.value
    //   }               
    
    try {
      const response = await fetch(API_URL+'/api/createjob',
        {
          method: "POST",          
          headers: { "Content-Type": "application/json","Authorization": "Bearer "+user.token },
          body: JSON.stringify(newTask)
        }
      ) ;

      if (response.ok) {
        //alert('Successfully send request!')
        triggerAlert("Successfully send request.")
      }
      else
        throw new Error('Something went wrong');      

    } catch (error) {
      console.log('There was an error');
      //alert('There was an error')
      triggerAlert("There was an error")
    }    
                   
  }
  
  return (
    <div className="container">
      {/* Header 
      <div className="header-1">
        <button className="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back to Roles
        </button>
      </div>
      */}
      {/* Main Content */}
      <div className="main-content-1">
        {/* Left Column - Profile */}
        <div className="profile-column">
          <div className="profile-image-container">
            <img 
              src={template.photo}
              alt="Healthcare professional" 
              className="profile-image"
            />
           
          </div>
          
          <div className="profile-info">
            <h2 className="profile-name">{template.name}</h2>
            <h3 className="profile-role">{template.service}</h3>
            <p className="profile-description">
               {template.introduction}
            </p>
          </div>
        </div>

        {/* Right Column - Details */}
        <div className="details-column">
          <h1 className="page-title">Test Voice Chat</h1>
          
           <VoiceChat/>
      
        </div>
      </div>

       <Alert
        show={showAlert}
        onClose={() => setShowAlert(false)}
        message={alertMessage}
      />

    </div>
  );
};

export default AutoCheckIn;